import { clone } from "ramda";
import { fetchDisclosureData } from "../server/fetchDisclosureData";
import { MAX_NUMBER_OF_DISCLAIMER_LOAD_ATTEMPTS, DISCLAIMER_LOAD_BACKOFF_MILLISECONDS, MAX_NUMBER_OF_LAST_DIFFERING_RECOMMENDATION_LOAD_ATTEMPTS, LAST_DIFFERING_RECOMMENDATION_LOAD_BACKOFF_MILLISECONDS } from "../constants";

export const SUBMIT_RECOMMENDATIONS_SUCCESS = "SUBMIT_RECOMMENDATIONS_SUCCESS";

export const REQUEST_FETCH_DISCLAIMERS = "REQUEST_FETCH_DISCLAIMERS";
export const RECEIVE_DISCLAIMERS_RESULTS = "RECEIVE_DISCLAIMERS_RESULTS";
export const LOAD_DISCLAIMERS_FAILED = "LOAD_DISCLAIMERS_FAILED";

export const REQUEST_FETCH_LAST_DIFFERING_RECOMMENDATION = "REQUEST_FETCH_LAST_DIFFERING_RECOMMENDATION";
export const RECEIVE_LAST_DIFFERING_RECOMMENDATION_RESULT = "RECEIVE_LAST_DIFFERING_RECOMMENDATION_RESULT";
export const LOAD_LAST_DIFFERING_RECOMMENDATION_FAILED = "LOAD_LAST_DIFFERING_RECOMMENDATION_FAILED";


export function submitRecommendationsSuccess(response) {
    return {
        type: SUBMIT_RECOMMENDATIONS_SUCCESS,
        payload: response
    };
}

export function receiveDisclaimersResult(disclosureId, disclaimers) {
    return {
        type: RECEIVE_DISCLAIMERS_RESULTS,
        payload: { disclosureId, disclaimers }
    };
}

export function loadDisclaimersFailed(disclosureId, errors) {
    return {
        type: LOAD_DISCLAIMERS_FAILED,
        payload: { disclosureId, errors }
    };
}

export function requestFetchDisclaimers(disclosureId) {
    return {
        type: REQUEST_FETCH_DISCLAIMERS,
        payload: { disclosureId }
    };
}

export function loadDisclaimers(disclosureId, disclaimersUri) {
    return (dispatch, getState) => {
        const numberOfAttempts = getState().recorder.recentDisclosures[disclosureId].numberOfAttempts;
        if (numberOfAttempts >= MAX_NUMBER_OF_DISCLAIMER_LOAD_ATTEMPTS) {
            dispatch(loadDisclaimersFailed(disclosureId, [`Disclaimers not available after ${numberOfAttempts} attempts`]));
            return;
        }

        dispatch(requestFetchDisclaimers(disclosureId));
        fetchDisclosureData(disclaimersUri, "disclaimers", response => {
            if (response.failed) {
                if(response.failed.canRetry) {
                    setTimeout(
                        () => dispatch(loadDisclaimers(disclosureId, disclaimersUri)),
                        DISCLAIMER_LOAD_BACKOFF_MILLISECONDS);
                } else {
                    dispatch(loadDisclaimersFailed(disclosureId, response.failed.errors));
                }
            } else {
                dispatch(receiveDisclaimersResult(disclosureId, response.disclaimers));
            }
        });
    }
}


export function receiveLastDifferingRecommendationResult(disclosureId, recommendation) {
    return {
        type: RECEIVE_LAST_DIFFERING_RECOMMENDATION_RESULT,
        payload: { disclosureId, recommendation }
    };
}

export function loadLastDifferingRecommendationFailed(disclosureId, errors) {
    return {
        type: LOAD_LAST_DIFFERING_RECOMMENDATION_FAILED,
        payload: { disclosureId, errors }
    };
}

export function requestFetchLastDifferingRecommendation(disclosureId) {
    return {
        type: REQUEST_FETCH_LAST_DIFFERING_RECOMMENDATION,
        payload: { disclosureId }
    };
}

export function loadLastDifferingRecommendation(disclosureId, disclosureUri) {
    return (dispatch, getState) => {
        const numberOfAttempts = getState().recorder.recentDisclosures[disclosureId].numberOfAttemptsForLastDifferingRecommendation;
        if (numberOfAttempts >= MAX_NUMBER_OF_LAST_DIFFERING_RECOMMENDATION_LOAD_ATTEMPTS) {
            dispatch(loadLastDifferingRecommendationFailed(disclosureId, [`Last differing recommendation not available after ${numberOfAttempts} attempts`]));
            return;
        }

        dispatch(requestFetchLastDifferingRecommendation(disclosureId));
        fetchDisclosureData(disclosureUri + "/last-differing", "last differing recommendation", response => {
            if (response.failed) {
                if(response.failed.canRetry) {
                    setTimeout(
                        () => dispatch(loadLastDifferingRecommendation(disclosureId, disclosureUri)),
                        LAST_DIFFERING_RECOMMENDATION_LOAD_BACKOFF_MILLISECONDS);
                } else {
                    dispatch(loadLastDifferingRecommendationFailed(disclosureId, response.failed.errors));
                }
            } else {
                dispatch(receiveLastDifferingRecommendationResult(disclosureId, response.last_differing_recommendation));
            }
        });
    }
}




/** WEBPACK FOOTER **
 ** ./src/main/javascript/recorder/actions/recordingActions.js
 **/